import retrieveDaqsJson from './retrieve-daqs-json'
import tableAdapter from './tableAdapter'
import boatBins from './filters/boatBins'
import measures from './filters/measures'
import { components } from '@datavue/datavue-ui'
import statesWithRegions from './filters/statesWithRegions'
const ChloroplethHeatmap = () =>
  import('../components/charts/ChloroplethHeatmap')
const HorizontalBarchart = () =>
  import('../components/charts/HorizontalBarchart')
const GenericPage = () => import('@/components/pages/GenericPage')
const DaqsChart = () => import('@/components/DaqsChart')
export default class Safety {
  title = 'Boating Safety'
  key = 'safety'
  pageComponent = GenericPage
  retrieveData = retrieveDaqsJson
  filters = function () {
    return {
      question: {
        key: 'question',
        label: 'View results for the question:',
        component: components['DatavueUiSelect'],
        options: [
          {
            key: 'killchord',
            label:
              'For operated engine-powered boats, was the boat equipped with a safety cut-out switch?',
            default: true
          },
          {
            key: 'vhsradio',
            label: 'For operated boats, Was a VHF-DSC radio on board?'
          }
        ]
      },
      filter1boatbin: {
        label: 'Boat Category:',
        component: components['DatavueUiSelect'],
        options: boatBins.map(bb => {
          let bb2 = { ...bb }
          bb2.default = (bb.key === 'MotorizedBoats')
          return bb2
        })
      },
      filter2stateorregion: {
        label: 'State/Region of Operation:',
        component: components['DatavueUiSelect'],
        options: statesWithRegions
      },
      measure: {
        label: 'Display results as:',
        component: components['DatavueUiRadioGroup'],
        props: {
          inline: true
        },
        options: measures
      }
    }
  }
  charts = function () {
    return {
      overall: {
        title: '',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      state_registered: {
        title: 'By State of Operation',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          grid: 'map',
          tableLabel: 'State of Operation',
          tableAdapter: tableAdapter
        }
      },
      region_registered: {
        title: 'By Region of Operation',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'region',
          grid: 'map',
          tableLabel: 'Region of Operation',
          tableAdapter: tableAdapter
        }
      },
      boatbin: {
        title: 'By Boat Category',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableLabel: 'Boat Category',
          tableAdapter: tableAdapter
        }
      }
    }
  }
}
